<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import Pharmacy from "./Pharmacy.svelte";

    let pharmacyList: any[]
    let offset: number = 0
    let page: number = 1
    let pharmacyLength: number
    let maxItems: number = 15
    let pharmacyCount: number;
    let promiseCount
    let promisePharmacy
    export let username;

    const dispatcher = createEventDispatcher()

    const nextPage = () => {
        dispatcher("verifySession")
        offset += pharmacyLength
        page += 1
        promisePharmacy = fetchPharmacy(offset)
    }

    const previousPage = () => {
        dispatcher("verifySession")
        offset -= maxItems
        page -= 1
        promisePharmacy = fetchPharmacy(offset)
    }

    const submit = (e) => {
        dispatcher("verifySession")
        fetchUpdatePharmacy(e.target[0].value, e.target[1].value, e.target[2].value, e.target[3].value, e.target[4].value).then(() => {
            promiseCount = fetchPharmacyCount()
            promisePharmacy = fetchPharmacy(offset)
        })
    }

    async function fetchPharmacyCount(){
        let res = await fetch("/pharmacy/count/")
        let data = await res.json()
        pharmacyCount = data.data.count
    }

    async function fetchPharmacy(offset: number) {
		let res = await fetch("/pharmacy/getByOffset/" + String(offset))
		let data = await res.json()
        pharmacyList = data.data
        pharmacyLength = pharmacyList.length
	}

    async function fetchUpdatePharmacy(id: number, name: string, street: string, location: string, phone: string){
        dispatcher("verifySession")
        let res = await fetch("/pharmacy/updatePharmacyEntry", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                pharmacy:{
                    id: id,
                    name: name,
                    street: street,
                    location: location,
                    phone: phone
                },
                username: username
            })
        });
        return res
    }

    promiseCount = fetchPharmacyCount()
    promisePharmacy = fetchPharmacy(offset)
</script>
<div>
    {#await promisePharmacy}
    <div></div>
    {:then}
    <div class="divide-y-2 divide-gray-400">
        <div class="grid grid-cols-6">
            <div class="p-1">ID</div>
            <div class="p-1">Name</div>
            <div class="p-1">Straße</div>
            <div class="p-1">Ort</div>
            <div class="p-1">Telefon</div>
            <div class="p-1"></div>
        </div>
        {#each pharmacyList as pharmacy}
        <form class="grid grid-cols-6 divide-x-2 divide-gray-400" on:submit|preventDefault={submit}>
            <input readonly class="cursor-default mr-1 mb-1 p-1 focus:underline focus:outline-none" value="{pharmacy.id}" />
            <input class="col-start-2 mr-1 mb-1 p-1 focus:underline focus:outline-none" value="{pharmacy.name}"/>
            <input class="col-start-3 mr-1 mb-1 p-1 focus:underline focus:outline-none" value="{pharmacy.street}" />
            <input class="col-start-4 mr-1 mb-1 p-1 focus:underline focus:outline-none" value="{pharmacy.location}" />
            <input class="col-start-5 mr-1 mb-1 p-1 focus:underline focus:outline-none" value="{pharmacy.phone}" />
            <input type="submit" value="Update" class="col-start-6 p-1 cursor-pointer hover:bg-gray-400"/>
        </form>
        {/each}
    </div>
    <div class="flex justify-center space-x-4 mt-3">
        {#if page === 1}
        <div class="text-gray-400 select-none">&lt;&lt;</div>
        {:else}
        <div class="cursor-pointer select-none" on:click="{previousPage}">&lt;&lt;</div>
        {/if}
        <div>Seite {page}</div>
        {#if (offset+15) < pharmacyCount}
        <div class="cursor-pointer select-none" on:click="{nextPage}">&gt;&gt;</div>
        {:else}
        <div class="text-gray-400 select-none">&gt;&gt;</div>
        {/if}
    </div>
    {/await}
</div>